import { APIMethod, fetchData, persistUserData } from "@client";

export async function authorizeMsSsoUserQuery(accessToken) {
  const { data, headers } =  await fetchData("/v1/sso", APIMethod.GET, {
    headers: { "Auth-a": accessToken },
    noAuth: true, returnFullResponse: true
  });
  await persistUserData(data.user.id, headers.token, true);
  return data.user;
}